import { useMemo, useState } from 'react';
import SectionHeading from '@/components/base/SectionHeading';
import Reveal from '@/components/base/Reveal';
import { galleryCategories, galleryItems } from '@/mocks/home';

export default function GallerySection() {
  const [active, setActive] = useState('全部');

  const filtered = useMemo(
    () => (active === '全部' ? galleryItems : galleryItems.filter((item) => item.category === active)),
    [active],
  );

  return (
    <section id="gallery" className="bg-background-50 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex flex-col gap-8 lg:flex-row lg:items-end lg:justify-between">
          <SectionHeading
            eyebrow="图片资源"
            title="精选图片资源，按类型快速取用"
            desc="壁纸、摄影、插画与设计素材四类分开整理，每张图片都标注了尺寸与适用场景。切换分类即可筛选当前页面的图片。"
          />

          <div className="flex flex-wrap gap-2" role="tablist" aria-label="图片分类筛选">
            {galleryCategories.map((category) => {
              const isActive = category === active;
              return (
                <button
                  key={category}
                  type="button"
                  role="tab"
                  aria-selected={isActive}
                  onClick={() => setActive(category)}
                  className={`whitespace-nowrap rounded-full border px-4 py-2 text-sm transition-colors ${
                    isActive
                      ? 'border-primary-500 bg-primary-500 text-background-50 dark:text-foreground-950'
                      : 'border-background-300 bg-background-50 text-foreground-700 hover:border-primary-300 hover:text-foreground-950'
                  }`}
                >
                  {category}
                </button>
              );
            })}
          </div>
        </div>

        <p className="mt-6 text-sm text-foreground-500">
          当前分类：<span className="text-foreground-900">{active}</span>，共 {filtered.length} 项内容
        </p>

        <div
          data-product-shop
          className="mt-6 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4"
        >
          {filtered.map((item, index) => (
            <Reveal key={item.id} delay={index * 60}>
              <article className="group flex h-full flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50">
                <div className="h-52 w-full overflow-hidden bg-background-100 sm:h-48">
                  <img
                    src={item.image}
                    alt={`${item.title}｜香蕉社区${item.category}资源`}
                    title={`${item.title} 香蕉社区图片资源`}
                    className="h-full w-full object-top object-cover transition-transform duration-500 group-hover:scale-105"
                  />
                </div>
                <div className="flex flex-1 flex-col p-4">
                  <span className="w-fit rounded-full bg-accent-100 px-2.5 py-1 text-xs text-accent-900">
                    {item.category}
                  </span>
                  <h3 className="mt-3 font-heading text-base font-semibold text-foreground-950">
                    {item.title}
                  </h3>
                  <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-600">
                    {item.desc}
                  </p>
                  <p className="mt-4 border-t border-background-200 pt-3 text-xs text-foreground-500">
                    {item.meta}
                  </p>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}